<div class="container-fluid">
  <div class="row justify-content-center mt-5">
    <div class="col-12 col-md-6 col-lg-5">

      @if (isLoading) {
        <div class="card shadow-sm">
          <div class="card-body text-center p-5">
            <fa-icon [icon]="['fas', 'spinner']" size="2x" animation="spin"></fa-icon>
          </div>
        </div>
      }

      @if (!isLoading && error) {
        <div class="card shadow-sm">
          <div class="card-body text-center p-5">
            <fa-icon [icon]="['fas', 'times-circle']" size="2x" class="text-danger mb-3 d-block"></fa-icon>
            <p>{{ error }}</p>
            <a routerLink="/borgenar/start" class="btn-garanti btn-blue mt-2">{{ 'group.accept-error-home' | translate }}</a>
          </div>
        </div>
      }

      @if (!isLoading && !error && !accepted && details) {
        <div class="card shadow-sm">
          <div class="card-body p-5">
            <div class="text-center mb-4">
              <fa-icon [icon]="['fas', 'users']" size="2x" class="text-primary mb-3 d-block"></fa-icon>
              <h4>{{ 'group.accept-title' | translate }}</h4>
            </div>
            @if (details.isExpired || details.isRevoked || details.isAlreadyAccepted) {
              <div
                class="alert alert-warning">
                @if (details.isExpired) {
                  <span>{{ 'group.accept-expired' | translate }}</span>
                }
                @if (details.isRevoked && !details.isExpired) {
                  <span>{{ 'group.accept-revoked' | translate }}</span>
                }
                @if (details.isAlreadyAccepted && !details.isExpired && !details.isRevoked) {
                  <span>
                    {{ 'group.accept-already-accepted' | translate }}
                  </span>
                }
              </div>
            }
            @if (!details.isExpired && !details.isRevoked && !details.isAlreadyAccepted) {
              <div>
                <p>
                  <strong>{{ details.invitedByName }}</strong> {{ 'group.accept-inviter-body' | translate }}
                </p>
                <p class="text-muted" style="font-size:13px">
                  {{ 'group.accept-expires' | translate: { date: (details.expiresUtc | localizeddate:'yyyy-MM-dd') } }}
                </p>
                @if (isAlreadyInAGroup) {
                  <div class="alert alert-warning mt-3 mb-0">
                    {{ 'group.accept-already-in-group' | translate }}
                    <div class="mt-3">
                      <button class="btn btn-sm btn-warning" (click)="leaveGroup()" [disabled]="isLeavingGroup">
                        @if (isLeavingGroup) {
                          <fa-icon [icon]="['fas', 'spinner']" animation="spin" class="me-1"></fa-icon>
                        }
                        @if (!isLeavingGroup) {
                          <fa-icon [icon]="['fas', 'sign-out-alt']" class="me-1"></fa-icon>
                        }
                        {{ (isLeavingGroup ? 'group.accept-leaving' : 'group.accept-leave-button') | translate }}
                      </button>
                    </div>
                  </div>
                }
                @if (!isAlreadyInAGroup) {
                  <div class="d-flex gap-2 mt-4">
                    <button class="btn-garanti btn-blue flex-grow-1" (click)="accept()"
                      [disabled]="isAccepting">
                      <fa-icon [icon]="['fas', 'check']" class="me-1"></fa-icon>
                      {{ (isAccepting ? 'group.accept-accepting' : 'group.accept-button') | translate }}
                    </button>
                    <button class="btn btn-outline-secondary" (click)="decline()">
                      {{ 'group.accept-decline' | translate }}
                    </button>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }

      @if (accepted) {
        <div class="card shadow-sm">
          <div class="card-body text-center p-5">
            <fa-icon [icon]="['fas', 'check-circle']" size="2x" class="text-success mb-3 d-block"></fa-icon>
            <h5>{{ 'group.accept-success-title' | translate }}</h5>
            <p class="text-muted">{{ 'group.accept-success-subtitle' | translate }}</p>
          </div>
        </div>
      }

    </div>
  </div>
</div>
